import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Ag1BadgeBaseComponent } from '../ag1-badge-base/ag1-badge-base.component';

@Component({
  selector: 'ag1-badge-solid',
  templateUrl: './ag1-badge-solid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Ag1BadgeSolidComponent extends Ag1BadgeBaseComponent {}
